import React from 'react';
import { AdvertorialButton } from '../ui/AdvertorialButton';
export function WhatHappensNextSection() {
  const offerIncludes = ['6 application-ready stickers', 'Clear application instructions', 'EMF meter testing guide', 'Lifetime protection (no replacements needed)'];
  const bonuses = ['Free EMF meter readings guide', 'Access to Australian customer group (Facebook community of users measuring results together)', 'Priority support for application questions'];
  const steps = [{
    title: 'Step 1: Order (Takes 2 minutes)',
    items: ['Go to [website]', 'Select quantity (6-pack, 12-pack, or 24-pack for larger family)', 'Enter shipping address (Australian delivery only)', 'Complete checkout']
  }, {
    title: 'Step 2: Apply (Takes 15 minutes total)',
    items: ['Receive stickers within [X business days]', 'Follow included instructions (takes ~2 minutes per device)', 'Wait 24 hours for full cure']
  }, {
    title: 'Step 3: Measure (Takes 10 minutes)',
    items: ['Get EMF meter (rent online or borrow from a friend)', 'Take baseline readings of your devices', 'Apply stickers', 'Re-measure after 24 hours', 'See the reduction for yourself']
  }];
  return <section className="w-full py-8 md:py-12 lg:py-16 px-4 md:px-6" style={{
    background: 'linear-gradient(135deg, #1B4F9E 0%, #2E5FBE 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-229">
      <div className="max-w-6xl mx-auto" data-id="element-230">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-10 text-center text-white" data-id="element-231">
          HERE'S WHAT HAPPENS NEXT
        </h2>

        {/* Three Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-232">
          {/* Column 1: The Offer */}
          <div className="p-6 md:p-7 rounded-lg" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(10px)'
        }} data-id="element-233">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-234">
              Buy 1 Get 1 Free
            </h3>
            <p className="text-[15px] text-white mb-2" data-id="element-235">
              <strong data-id="element-236">Product:</strong> QShield EMF Stickers 6-pack (protects 6
              devices)
            </p>
            <p className="text-[15px] text-white mb-4" data-id="element-237">
              <strong data-id="element-238">Price:</strong> 2 for the price of 1
            </p>

            <p className="text-[15px] text-white font-semibold mb-2" data-id="element-239">
              What's Included:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-240">
              {offerIncludes.map((item, index) => <li key={index} className="flex items-start gap-2 text-[15px] text-white" data-id="element-241">
                  <span style={{
                color: '#2D9B6E'
              }} data-id="element-242">
                    •
                  </span>
                  <span data-id="element-243">{item}</span>
                </li>)}
            </ul>

            <p className="text-[15px] text-white font-semibold mb-2" data-id="element-244">
              Bonus (If Applicable):
            </p>
            <ul className="space-y-2" data-id="element-245">
              {bonuses.map((item, index) => <li key={index} className="flex items-start gap-2 text-[15px] text-white" data-id="element-246">
                  <span style={{
                color: '#2D9B6E'
              }} data-id="element-247">
                    •
                  </span>
                  <span data-id="element-248">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Column 2: The Guarantee */}
          <div className="p-6 md:p-7 rounded-lg" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }} data-id="element-249">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-250">
              The Guarantee
            </h3>
            <p className="text-sm text-white font-semibold mb-3" data-id="element-251">
              Our Commitment to You:
            </p>
            <p className="text-sm text-white mb-4" style={{
            lineHeight: '1.7'
          }} data-id="element-252">
              Apply QShield stickers to your family's devices. Use them for 90
              days. Measure the EMF reduction with a meter (we'll show you how).
              If you don't see the measurable reduction we promised—or if for
              any reason you're not satisfied—contact us and we'll refund your
              full purchase price. No questions asked. No hassle.
            </p>
            <p className="text-sm text-white" style={{
            lineHeight: '1.7'
          }} data-id="element-253">
              This guarantee is real because we're confident in what the product
              does. We're not claiming it will 'cure' anything. We're claiming
              it reduces measurable EMF radiation. That's measurable. That's
              verifiable. And we stand behind it.
            </p>

            {/* Guarantee Badge */}
            <div className="inline-block mt-4 px-3 py-2 rounded text-xs font-semibold text-white" style={{
            backgroundColor: '#2D9B6E'
          }} data-id="element-254">
              ✓ 90-Day Money-Back Guarantee
            </div>
          </div>

          {/* Column 3: The Process */}
          <div className="p-6 md:p-7 rounded-lg" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }} data-id="element-255">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-256">
              The Three-Step Process
            </h3>

            {steps.map((step, stepIndex) => <div key={stepIndex} className="mb-4 last:mb-0" data-id="element-257">
                <p className="text-[15px] text-white font-semibold mb-2" data-id="element-258">
                  {step.title}
                </p>
                <ul className="space-y-1" data-id="element-259">
                  {step.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start gap-2 text-[15px] text-white" data-id="element-260">
                      <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold text-white mt-0.5" style={{
                  backgroundColor: '#2D9B6E'
                }} data-id="element-261">
                        {itemIndex + 1}
                      </span>
                      <span data-id="element-262">{item}</span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        {/* Primary CTA Button */}
        <div className="text-center mt-10" data-id="element-263">
          <AdvertorialButton variant="primary" data-id="element-264">
            ORDER YOUR QSHIELD 6-PACK NOW
          </AdvertorialButton>
          <p className="mt-4 text-sm" style={{
          color: 'rgba(255, 255, 255, 0.9)'
        }} data-id="element-265">
            90-day guarantee. Australian delivery. Measured protection.
          </p>
        </div>
      </div>
    </section>;
}